import {
  EAffiliatePartnerUserAccessStatus,
  EAffiliatePartnerUserStatus,
  EBankAccountType,
  ECommissionStatus,
  EConsumerUnitClassification,
  EConsumerUnitTension,
  EIndicationOrigin,
  EIndicationStatus,
  EMaritalStatus,
  EPersonType,
  ETariffClassification,
} from "~/graphql/types";
import {
  translateComissionsStatus,
  translateIndicationsOriginStatus,
  translateIndicationsStatus,
} from "./translate";

export type Option = {
  label: string;
  value: string;
};

export const defaultOption: Option = {
  value: "",
  label: "",
};

export const personTypeOptions: Option[] = [
  { value: EPersonType.pf, label: "Pessoa Física" },
  { value: EPersonType.pj, label: "Pessoa Jurídica" },
];

export const maritalStatusOptions: Option[] = [
  { value: EMaritalStatus.married, label: "Casado(a)" },
  { value: EMaritalStatus.single, label: "Solteiro(a)" },
  { value: EMaritalStatus.divorced, label: "Divorciado(a)" },
  { value: EMaritalStatus.widowed, label: "Viúvo(a)" },
];

export const tariffClassificationOptions: Option[] = [
  { value: ETariffClassification.A4, label: "A4" },
  { value: ETariffClassification.B1, label: "B1" },
  { value: ETariffClassification.B2, label: "B2" },
  { value: ETariffClassification.B3, label: "B3" },
];

export const customerTensionOptions: Option[] = [
  { value: EConsumerUnitTension.monofasico, label: "Monofásico" },
  { value: EConsumerUnitTension.bifasico, label: "Bifásico" },
  { value: EConsumerUnitTension.trifasico, label: "Trifásico" },
];

export const getConsumerClassificationOptions = (
  tariffClassification: ETariffClassification | ETariffClassification,
): Option[] => {
  switch (tariffClassification) {
    case ETariffClassification.A4:
      return [
        { value: EConsumerUnitClassification.industrial, label: "Industrial" },
      ];
    case ETariffClassification.B1:
      return [
        {
          value: EConsumerUnitClassification.residencial,
          label: "Residencial",
        },
      ];
    case ETariffClassification.B2:
      return [{ value: EConsumerUnitClassification.rural, label: "Rural" }];
    case ETariffClassification.B3:
      return [
        { value: EConsumerUnitClassification.comercial, label: "Comercial" },
        { value: EConsumerUnitClassification.industrial, label: "Industrial" },
      ];
    default:
      return [defaultOption];
  }
};

export const bankAccountTypeOptions: Option[] = [
  { value: EBankAccountType.cc, label: "Conta corrente" },
  { value: EBankAccountType.cp, label: "Poupança" },
];

export const accountOwnerOptions: Option[] = [
  { value: "company", label: "Empresa" },
  { value: "legalRepresentative", label: "Representante legal" },
];

export const userStatusOptions: Option[] = [
  { value: EAffiliatePartnerUserStatus.underAnalysis, label: 'Em Análise' },
  { value: EAffiliatePartnerUserStatus.approved, label: 'Aprovado' },
  { value: EAffiliatePartnerUserStatus.rejected, label: 'Reprovado' },
]

export const userAccessStatusOptions: Option[] = [
  { value: EAffiliatePartnerUserAccessStatus.allowed, label: 'Permitido' },
  { value: EAffiliatePartnerUserAccessStatus.notAllowed, label: 'Não Permitido' },
]

export const indicationsStatusOptions: Option[] = [
  {
    value: EIndicationStatus.pending,
    label: translateIndicationsStatus(EIndicationStatus.pending),
  },
  {
    value: EIndicationStatus.canceled,
    label: translateIndicationsStatus(EIndicationStatus.canceled),
  },
  {
    value: EIndicationStatus.requestedProposal,
    label: translateIndicationsStatus(EIndicationStatus.requestedProposal),
  },
  {
    value: EIndicationStatus.expiredProposal,
    label: translateIndicationsStatus(EIndicationStatus.expiredProposal),
  },
  {
    value: EIndicationStatus.awaitingSignature,
    label: translateIndicationsStatus(EIndicationStatus.awaitingSignature),
  },
  {
    value: EIndicationStatus.proposalUnderAudit,
    label: translateIndicationsStatus(EIndicationStatus.proposalUnderAudit),
  },
  {
    value: EIndicationStatus.canceledProposal,
    label: translateIndicationsStatus(EIndicationStatus.canceledProposal),
  },
  {
    value: EIndicationStatus.signedContract,
    label: translateIndicationsStatus(EIndicationStatus.signedContract),
  },
  {
    value: EIndicationStatus.activeContract,
    label: translateIndicationsStatus(EIndicationStatus.activeContract),
  },
  {
    value: EIndicationStatus.canceledContract,
    label: translateIndicationsStatus(EIndicationStatus.canceledContract),
  },
  {
    value: EIndicationStatus.contractWithPendencies,
    label: translateIndicationsStatus(EIndicationStatus.contractWithPendencies),
  },
];

export const indicationOriginStatusOptions: Option[] = [
  {
    value: EIndicationOrigin.api,
    label: translateIndicationsOriginStatus(EIndicationOrigin.api),
  },
  {
    value: EIndicationOrigin.link,
    label: translateIndicationsOriginStatus(EIndicationOrigin.link),
  },
  {
    value: EIndicationOrigin.partnerArea,
    label: translateIndicationsOriginStatus(EIndicationOrigin.partnerArea),
  },
];

export const comissionStatusOptions: Option[] = [
  {
    value: ECommissionStatus.canceled,
    label: translateComissionsStatus(ECommissionStatus.canceled),
  },
  {
    value: ECommissionStatus.extension,
    label: translateComissionsStatus(ECommissionStatus.extension),
  },
  {
    value: ECommissionStatus.late,
    label: translateComissionsStatus(ECommissionStatus.late),
  },
  {
    value: ECommissionStatus.notPaid,
    label: translateComissionsStatus(ECommissionStatus.notPaid),
  },
  {
    value: ECommissionStatus.paid,
    label: translateComissionsStatus(ECommissionStatus.paid),
  },
];
